<div class="contentHeight assistance">
  <mat-horizontal-stepper labelPosition="bottom" #stepper class="mat-stepper-horizontal backgroundWhiteRound" linear>
    <!-- 1. Code Balance -->
    <mat-step [stepControl]="scaleForm">
      <form>
        <ng-template matStepLabel><span class="respLabel" [translate]="'assistance.scaleCode'"></span></ng-template>
        <div class="titleLabel">
          <h1 class="text-center" [translate]="'assistance.scaleCode'"></h1>
          <hr class="col-12 mx-auto">
        </div>
        <div class="flex flex-wrap balIdContainer">
            <ng-container *ngIf="Utils.isIxellColorWeb(scale)">
                <img class="imgScale" src="assets/etiquettesBalances/Ixell Color V1_0.png" alt="" />
                <img class="imgScale" src="assets/etiquettesBalances/Ixell Color V1_ZOOM.png" alt="" />
            </ng-container>
            <ng-container *ngIf="Utils.isIxellColorTouch(scale)">
                <img class="imgScale" src="assets/etiquettesBalances/Ixell Color V2_0.png" alt="" />
                <img class="imgScale" src="assets/etiquettesBalances/Ixell Color V2_ZOOM.png" alt="" />
            </ng-container>
            <ng-container *ngIf="Utils.isIxellColorConnect(scale)">
                <img class="imgScale" src="assets/balance/IxellConnect-Zoom.png" alt="" />
            </ng-container>
            <div class="form-group row justify-content-center flex-grow-1 scaleformCtn">
                <div [formGroup]="scaleForm" class="scaleform">
                    <mat-form-field class="col-12">
                        <mat-label *ngIf="scale == '1' || scale == '2'" [translate]="'assistance.scaleText1'"></mat-label>
                        <mat-label *ngIf="scale == '4'" [translate]="'assistance.scaleText2'"></mat-label>
                        <input matInput formControlName="serialNumberScale" placeholder={{formatMsg}} required>
                        <mat-error>{{errorScale|translate}}</mat-error>
                    </mat-form-field>

                    <div *ngIf="errorScaleMsg"><span class="invalid-form" [translate]="'scaleform.errorcode'"></span></div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
          <!-- <button class="btn btn-secondary" matStepperNext [translate]="'scaleform.suivant'" (click)="verifyScale()"></button> -->
          <button class="btn btn-secondary" (click)="verifyScale()" [translate]="'scaleform.suivant'"> </button>
          <button class="btn btn-secondary" id="scaleStepper" style="display:none;" matStepperNext></button>
        </div>
      </form>
    </mat-step>
    <!-- 2. Type de panne -->
    <mat-step [stepControl]="breakdownForm">
      <form>
        <ng-template matStepLabel> <span class="respLabel" [translate]="'assistance.breakdownType'"></span> </ng-template>
        <div class="titleLabel">
          <h1 class="text-center" [translate]="'assistance.breakdownType'"></h1>
          <hr class="col-12 mx-auto">
        </div>
        <div class="form-group row justify-content-center mb-0">
          <div [formGroup]="breakdownForm" class="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div class="mt-4 mb-4">
              <h5 [translate]="'assistance.breakdownText'"></h5>
            </div>
            <mat-radio-group formControlName="breakdownType" id="breakdownType">
              <mat-radio-button class="mr-2 mt-2 my-radio"
                                *ngFor="let breakdown of breakdownType.breakdown"
                                [value]="breakdown.value"
                                (click)="removeRadioError('breakdownType'); displayMaintenance(breakdown.value)">
                <span id="radio{{breakdown.value}}">{{breakdown.name|translate}}</span>
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
        <div class="row justify-content-center">
          <button class="btn btn-secondary mr-2" matStepperPrevious [translate]="'scaleform.precedent'"></button>
          <button class="btn btn-secondary" matStepperNext [translate]="'scaleform.suivant'"></button>
        </div>
      </form>
    </mat-step>
    <!-- 3. Informations -->
    <mat-step [stepControl]="contactAssistForm">
      <ng-template matStepLabel> <span class="respLabel" [translate]="'assistance.info'"></span></ng-template>
      <div class="titleLabel">
        <h1 class="text-center" [translate]="'assistance.info'"></h1>
        <hr class="col-12 mx-auto">
      </div>
      <div class="form-group row justify-content-center">
        <div [formGroup]="contactAssistForm" class="col-xl-6 col-lg-6 col-md-8 col-sm-12">
          <div class="mt-4">
            <h5 [translate]="'assistance.infoText'" *ngIf="isMaintenance == true"></h5>
            <h5 [translate]="'assistance.infoText2'" *ngIf="isMaintenance == false"></h5>
          </div>
          <div *ngIf="isDisplayMaintenance">
            <div class="mt-4 row">
              <div class="mb-2 col-xl-6 col-lg-8 col-md-7 col-sm-6">
                <span [translate]="'assistance.isRemoteMaintenance'"></span>
                <span> ?</span>
              </div>
              <div class="col-xl-6 col-lg-4 col-md-5 col-sm-6">
                <mat-radio-group>
                  <mat-radio-button class="mr-2" [value]="true" (click)="checkMaintenance(true)" [checked]="true"><span [translate]="'assistance.oui'"></span></mat-radio-button>
                  <mat-radio-button class="mr-2" [value]="false" (click)="checkMaintenance(false)"><span [translate]="'assistance.non'"></span></mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <mat-form-field class="col-12 px-0" *ngIf="isMaintenance">
              <mat-label [translate]="'assistance.remoteMaintenanceID'"></mat-label>
              <input matInput formControlName="remoteMaintenanceID">
            </mat-form-field>
          </div>
          <div class="mt-4">
            <span [translate]="'assistance.contact'"></span><span> :</span>
            <div class="mt-2">
              <mat-form-field class="col-6 pl-0">
                <mat-label [translate]="'scaleform.nom'"></mat-label>
                <input matInput formControlName="name" required>
              </mat-form-field>
              <mat-form-field class="col-6 pr-0">
                <mat-label [translate]="'scaleform.prenom'"></mat-label>
                <input matInput formControlName="firstname" required>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field class="col-12 px-0">
                <mat-label [translate]="'scaleform.mail'"></mat-label>
                <input matInput formControlName="mail" required>
                <mat-error [translate]="'scaleform.mailerror'"></mat-error>
              </mat-form-field>
            </div>
            <mat-form-field class="col-12 px-0">
              <mat-label [translate]="'assistance.phone'"></mat-label>
              <input matInput formControlName="phone" required>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="col-12 px-0">
              <mat-label [translate]="'assistance.comment'"></mat-label>
              <textarea matInput
                        formControlName="comment"
                        required
                        cdkTextareaAutosize
                        cdkAutosizeMinRows="5"
                        cdkAutosizeMaxRows="10">
              </textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
      <p id="text-error" *ngIf="invalidForm" class="invalid-form text-center" [translate]="'scaleform.errorform'"></p>
      <div class="row justify-content-center">
        <button class="btn btn-secondary" (click)="verifyScale(); sendDataAssist()" [translate]="'scaleform.envoyer'"></button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
  <div></div>
</div>
<!-- Modale confirmation -->
<div id="finalModal" class="modal">
  <div class="modal-content">
    <span class="text-right mr-2 pointer close" (click)="closeModal();">  <i class="fal fa-times fa-1x5 primaryRed" aria-hidden="true"></i> </span>
    <div class="container">
      <i class="fal fa-clipboard-check iconBackground" aria-hidden="true"></i>
      <div class="upperText">
        <h2 class="text-center" [translate]="'assistance.requestOkTitle'"></h2>
        <div class="row">
          <div class="col-lg-8 col-md-10 col-sm-12 mx-auto modalFin p-4">
            <p [translate]="'assistance.requestOkInfo'"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
